/**

 * Print Part Requests list as PDF (includes part photos when available).

 * Uses a hidden iframe to avoid popup blockers.

 */

import { resolvePhotoUrl } from './photoUrl';



export function printPartRequestsPdf(requests = [], meta = {}) {

  const title = meta.title || 'Part Requests';

  const generated = new Date().toLocaleString();

  const rows = (requests || []).map((r, i) => {

    const photo = resolvePhotoUrl(r.part_photo_url);

    const job =

      r.source === 'ssi'

        ? (r.ssi_job_id ? `SSI #${r.ssi_job_id}` : 'SSI')

        : (r.service_number || r.repair?.grn_number || r.repair?.service_number || `#${r.repair_id || ''}`);

    return `

      <tr>

        <td>${i + 1}</td>

        <td>${r.source === 'ssi' ? 'SSI' : 'Repair'}</td>

        <td>${job}</td>

        <td>${r.product_name || '-'}${r.product_code ? ` (${r.product_code})` : ''}</td>

        <td>${r.quantity ?? 1}</td>

        <td>${Number(r.unit_price || 0).toFixed(2)}</td>

        <td>${r.approved_unit_price != null ? Number(r.approved_unit_price).toFixed(2) : '-'}</td>

        <td>${r.requested_by_name || '-'}</td>

        <td>${r.status || '-'}</td>

        <td class="photo">${

          photo

            ? `<img src="${photo}" alt="part" crossorigin="anonymous" style="max-width:90px;max-height:90px;object-fit:cover;border-radius:4px;" />`

            : '—'

        }</td>

      </tr>`;

  }).join('');



  const html = `<!DOCTYPE html>

<html>

<head>

  <meta charset="utf-8" />

  <title>${title}</title>

  <style>

    body { font-family: Arial, sans-serif; padding: 16px; color: #222; }

    h1 { font-size: 18px; margin: 0 0 4px; }

    .meta { color: #666; font-size: 12px; margin-bottom: 16px; }

    table { width: 100%; border-collapse: collapse; font-size: 11px; }

    th, td { border: 1px solid #ccc; padding: 6px; vertical-align: middle; }

    th { background: #f5f5f5; text-align: left; }

    td.photo { text-align: center; width: 100px; }

    @media print { button { display: none; } }

  </style>

</head>

<body>

  <button type="button" onclick="window.print()">Print / Save PDF</button>

  <h1>${title}</h1>

  <div class="meta">Generated: ${generated} · Rows: ${(requests || []).length}</div>

  <table>

    <thead>

      <tr>

        <th>#</th><th>Source</th><th>Job</th><th>Part</th><th>Qty</th>

        <th>Req. Price</th><th>Approved</th><th>By</th><th>Status</th><th>Photo</th>

      </tr>

    </thead>

    <tbody>${rows || '<tr><td colspan="10">No part requests</td></tr>'}</tbody>

  </table>

</body>

</html>`;



  const iframe = document.createElement('iframe');

  iframe.setAttribute('title', 'Part Requests PDF');

  iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:none;';

  document.body.appendChild(iframe);



  const doc = iframe.contentDocument || iframe.contentWindow?.document;

  if (!doc) {

    document.body.removeChild(iframe);

    throw new Error('Could not open print preview');

  }



  doc.open();

  doc.write(html);

  doc.close();



  const triggerPrint = () => {

    try {

      iframe.contentWindow?.focus();

      iframe.contentWindow?.print();

    } finally {

      setTimeout(() => {

        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);

      }, 1500);

    }

  };



  iframe.onload = triggerPrint;

  setTimeout(triggerPrint, 500);

}


